<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="FinReceiveableOrderInfo"
                        :filter_language="['order_status']"
                        :filter_thousandth="['net_total_amount','vender_net_total_amount']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        :checkflg="false"
                        ref="singleTable"
                ></wTable>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div>
                        <el-button type="primary" size="mini"  @click.native.prevent="audit()" :disabled="dataDetail.Head.order_status != 0">{{$t('getapi[941]')}}</el-button>
                        <el-button type="primary" size="mini"  @click.native.prevent="reAudit()" :disabled="dataDetail.Head.order_status != 1">{{$t('getapi[1334]')}}</el-button>
                    </div>
                    <div style="width:630px;min-width:630px">
                        <table>
                            <tr>
                                <td style="width:60px;min-width:60px">{{$t('getapi[463]')}}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.order_no" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{$t('getapi[7576]')}}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-date-picker v-model="dataDetail.Head.order_date" size="mini" type="date" style="width: 100%"
                                                    :readonly="dataDetail.Head.order_status>0" :class="{'readO':dataDetail.Head.order_status>0,'mcolor':dataDetail.Head.order_status==0}"></el-date-picker>

                                </td>
                                <td style="width:60px;min-width:60px">{{$t('getapi[1861]')}}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" :value="expStatus(dataDetail.Head.order_status)" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[1228]')}}</td>
                                <td>
                                    <el-select filterable v-model="dataDetail.Head.balance_mode" size="mini" v-if="dataDetail.Head.order_status == 0">
                                        <el-option v-for="(item, index) in BalanceMode" :label="item.balance_mode"
                                                   :value="item.balance_mode" :key="index" ></el-option>
                                    </el-select>
                                    <el-input type="text" size="number" v-model="dataDetail.Head.customer_code" :readonly="true" class="readO" v-show="dataDetail.Head.order_status != 0"></el-input>
                                </td>
                                <td>{{$t('getapi[2610]')}}</td>
                                <td>
                                    <routejump :urlNo="26" v-if="dataDetail.Head.order_status == 0">
                                        <el-input
                                                v-model="dataDetail.Head.customer_code"
                                                type="text"
                                                readonly
                                                class="mcolor"
                                                size="mini"

                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcustomer()"></i>
                                        </el-input>
                                    </routejump>
                                    <el-input type="text" size="number" v-model="dataDetail.Head.customer_code" :readonly="true" class="readO" v-show="dataDetail.Head.order_status != 0"></el-input>
                                </td>
                                <td>{{$t('getapi[13424]')}}</td>
                                <td>
                                    <el-input
                                            v-model="dataDetail.Head.subject_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSubject()"></i>
                                    </el-input>
                                    <el-input type="text" size="number" v-model="dataDetail.Head.subject_code" :readonly="true" class="readO" v-show="dataDetail.Head.order_status != 0"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[8339]')}}</td>
                                <td>
                                    <el-select filterable v-model="dataDetail.Head.currency_code" size="mini" v-if="dataDetail.Head.order_status == 0">
                                        <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                                   :value="item.currency_code" :key="index" ></el-option>
                                    </el-select>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.currency_code" v-if="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{$t('getapi[3287]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.exchange_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{$t('getapi[2102]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.amount" class="mcolor" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                              :readonly="dataDetail.Head.order_status>0" :class="{'readO':dataDetail.Head.order_status>0}" @change="getBaseNetAmount"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[7941]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.base_net_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{$t('getapi[1628]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="dataDetail.Head.order_status>0" :class="{'readO':dataDetail.Head.order_status>0}"></el-input>
                                </td>
                                <td>{{ $t('getapi[1833]') }}</td>
                                <td>
                                    <routejump :urlNo="28" v-show="dataDetail.Head.order_status == 0">
                                        <el-input  type="text" v-model="dataDetail.Head.department"
                                                   readonly
                                                   size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpartment()"></i>
                                        </el-input>
                                    </routejump>
                                    <el-input type="text" size="number" v-model="dataDetail.Head.department" :readonly="true" class="readO" v-show="dataDetail.Head.order_status != 0"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[13547]')}}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.business_person" :readonly="dataDetail.Head.order_status>0" :class="{'readO':dataDetail.Head.order_status>0}"></el-input>
                                </td>
                                <td>{{ $t('getapi[1479]') }}</td>
                                <td>
                                    <routejump :urlNo="5" v-if="dataDetail.Head.order_status == 0">
                                        <el-input
                                                v-model="dataDetail.Head.item_code"
                                                type="text"
                                                readonly
                                                size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectitem()"></i>
                                        </el-input>
                                    </routejump>
                                    <el-input v-model="dataDetail.Head.item_code" type="text" size="mini" :readonly="true" class="readO"
                                              v-if="dataDetail.Head.order_status != 0"></el-input>
                                </td>
                                <td>{{$t('getapi[6738]')}}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.payment_terms" :readonly="dataDetail.Head.order_status>0" :class="{'readO':dataDetail.Head.order_status>0}"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[7340]')}}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.abstracts" :readonly="dataDetail.Head.order_status>0" :class="{'readO':dataDetail.Head.order_status>0}"></el-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="FinReceiveableOrderInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[5114]')" queryData="FinReceiveableOrderInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <!--选择客户代码-->
        <selector :isVisible="false" :selectType="0" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetSALCustomerDataList'" @callback="getcustomer" ref="customer"></selector>
        <!--选择会计科目-->
        <subjecttable :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
                      :postUrl="'/GL/Basic/GetSubjectPopuDataList'" @callback="getSubject" ref="subject"></subjecttable>
        <!--选择部门-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Pur/MRO/GetDepartmentInfoPopupList'" @callback="getpartment" ref="partment"></selector>
        <!--项目-->
        <selector :isVisible="false" :selectType="3" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetEngItemDataList'"
                  @callback="getitem" ref="item"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '3_receiveableview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_receiveableview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                loading: false, // 主表加载状态
                dataDetail:{
                    Head:{
                        order_no:'',
                        order_date:'',
                        vender_code:'',
                        currency_code:'',
                        exchange_rate:'',
                        order_status:'',
                        subject_code:'',
                        amount:'',
                        base_net_amount:'',
                        qty:'',
                        department:'',
                        bussiness_person:'',
                        item_code:'',
                        payment_terms:'',
                        abstracts:'',
                        create_person:'',
                        create_date:'',
                        modify_person:'',
                        modify_date:'',
                        audit_person:'',
                        audit_date:'',
                    },
                    Lists:[],
                },
                oldDataDetail: '',
                addoredit: 0,
                btn: {
                    audit: false,
                    reaudit: false,
                },
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                code: '',
                selectData:[],
                Currency:[], //货币数组
                BalanceMode:[],//结算方式数组
            };
        },
        beforeMount(){
            let that = this;
            that.colsort();
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('3_receiveableview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$http.urlpost('CurrencySource', {}, function (res) {
                if (res.Success == 1) {
                    that.Currency = res.DataContent;
                }
            });
            that.BalanceMode = Array.methods.GetBillingOptionsList()
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
            that.authority()
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('FinReceiveableOrderInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[5077]"),this.$t("getapi[5131]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                    if (that.dataDetail.Head.order_status > 0) {
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                    }
                } else {
                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_receiveableview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'FinReceiveableOrderInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Finance/ReceiveAble/ReceiveableView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndex)
                    });
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.order_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.order_no
                                that.getDetail(row.order_no)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.order_no
                        that.getDetail(row.order_no)
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.Lists.length; i++) {
                    delete datacopy.Lists[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let date= Common.methods.getDate();
                that.addoredit = 0;
                that.code = ''
                that.dataDetail = {
                    Head: {
                        order_no:'',
                        order_date:'',
                        customer_code:'',
                        balance_mode:'',
                        currency_code:'',
                        exchange_rate:'',
                        order_status:'',
                        subject_code:'',
                        amount:'',
                        base_net_amount:'',
                        qty:'',
                        department:'',
                        bussiness_person:'',
                        item_code:'',
                        payment_terms:'',
                        abstracts:'',
                        create_person:'',
                        create_date:'',
                        modify_person:'',
                        modify_date:'',
                        audit_person:'',
                        audit_date:'',
                    },
                    Lists:[]
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if(that.addoredit == 0){
                                that.confirmAdd()
                            } else {
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "FinReceiveableOrderInfo",
                    fromname: that.$t('getapi[13544]'),
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Finance/ReceiveAble/ReceiveableSaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                }
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Finance/ReceiveAble/GetReceiveableBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                    }
                    loadingInstance.close()
                });
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            Code: that.code,
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Finance/ReceiveAble/DeleteReceiveable', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                that.getView()
                                that.confirmAdd();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            selectcustomer(){
                let that = this
                that.$refs.customer.clearInput(true);
            },
            getcustomer(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.customer_code = data.customer_id
                that.dataDetail.Head.customer_name = data.customer_name
                that.dataDetail.Head.currency_code = data.currency_code_id
                that.dataDetail.Head.exchange_rate = data.tax_rate
            },
            selectSubject(){
                let that = this
                that.$refs.subject.clearInput(true);
            },
            getSubject(data){
                let that = this
                that.dataDetail.Head.subject_code = data['科目编码']
            },
            selectpartment(){
                let that = this;
                that.$refs.partment.clearInput(true);
            },
            getpartment(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.department = data.name
            },
            selectitem() {
                let that = this;
                that.isShowItem = true;
                that.$refs.item.clearInput(true);
            },
            getitem(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Head.item_code = val.item_name;
            },
            audit(){
                let that = this
                let parm = {
                    Code: that.dataDetail.Head.order_no,
                }
                that.$http.urlpost('/Finance/ReceiveAble/AuditReceiveable', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            reAudit(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    vender_code: that.dataDetail.Head.vender_code,
                    LangType:that.$processdata.getLang(),
                }
                that.$http.urlpost('/Finance/ReceiveAble/RAuditReceiveable', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            //获取本币金额
            getBaseNetAmount(){
                let that = this
                that.dataDetail.Head.base_net_amount = (that.dataDetail.Head.amount * that.dataDetail.Head.exchange_rate).toFixed(that.amountDigit)
            },
            expStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return that.$t('getapi[4643]')//'审核'
                } else if(val == 2){
                    return that.$t('getapi[1868]')//'记账'
                } else if(val == 3){
                    return that.$t('getapi[3754]')//'月结'
                } else {
                    return ''
                }
            },
            checkDataChange(){
                let that = this
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            },
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-textarea {
        display: block;
    }
</style>
